import { WasteClassification } from "generated-graphql/graphql";

/** The label-content fields the summary sentence reads. */
export type LabelSummaryContent = {
  classification?: WasteClassification | null;
  dotHazardClass?: string | null;
  qrUrl?: string | null;
};

const HAZARDOUS_CLASSIFICATIONS: WasteClassification[] = [
  WasteClassification.RcraHazardous,
  WasteClassification.RcraAcutelyHazardous,
];

/**
 * What the generated label actually contains, in a sentence.
 *
 * Every clause is conditional on the data being there, because the label is
 * assembled from the container's own record: a nonhazardous stream gets no
 * "HW" wording, a container with no DOT hazard class gets no placard clause,
 * and a label that has never been generated has no "Updated" date. Saying
 * otherwise would describe an artifact the reader isn't holding.
 */
export function labelSummarySentence(content: LabelSummaryContent | null | undefined): string {
  const isHazardous =
    content?.classification != null && HAZARDOUS_CLASSIFICATIONS.includes(content.classification);

  const parts: string[] = [isHazardous ? "Compliant HW label" : "Compliant waste label"];
  if (content?.dotHazardClass) {
    parts.push(`DOT Class ${content.dotHazardClass} placard`);
  }
  if (content?.qrUrl) {
    parts.push("QR");
  }

  return `${parts.join(" + ")}, built from this container's data.`;
}
